import { Booking } from '@/types';

/**
 * Booking statuses that never consume capacity: the work either will not happen
 * or is already done, so it must not reduce availability, count as booked hours
 * or create conflicts. Mirrors ResourcesController.NonConsumingBookingStatuses,
 * minus the American spelling the backend also tolerates for external data —
 * only these two are members of the BookingStatus union.
 */
const NON_CONSUMING_STATUSES = new Set(['cancelled', 'completed']);

export function consumesCapacity(booking: Pick<Booking, 'status'>): boolean {
  return !NON_CONSUMING_STATUSES.has(String(booking.status ?? '').toLowerCase());
}
